var pym = require("./lib/pym");
require("./lib/webfonts");
var { isMobile } = require("./lib/breakpoints");

var onWindowLoaded = function() {
  document.querySelector("#fallback").remove();

  const isTouchDevice = () => {
    return window.matchMedia('(hover: none)').matches;
  }

  var data = window.DATA.reduce(function(a, c) {
    a[c.Name] = c;
    return a;
  }, {});

  const tooltip = document.querySelector("#tooltip"),
    tooltipLink = document.querySelector("#tooltip-link");

  const positionTooltip = event => {
    if (event.target.dataset.lawmaker) {
      tooltip.classList.remove("hidden");
      tooltip.classList.add("visible");
    }
    if (event.clientX < 110) { // left side of window
      tooltip.style.left = event.clientX + "px";
    } else if (event.clientX > window.innerWidth - 110) { // right side of window
      tooltip.style.right = (window.innerWidth - event.clientX) + "px";
      tooltip.style.left = "auto";
    } else { // somewhere in the middle
      tooltip.style.left = (event.clientX - 110) + "px";
      tooltip.style.right = "auto";
    }
    tooltip.style.bottom = (document.querySelector("#graphic").getBoundingClientRect().bottom - event.clientY + 10) + "px";
  }

  const populateTooltipContent = event => {
    if (event.target.dataset.lawmaker) {
      const name = event.target.dataset.lawmaker;

      document.querySelector("#tooltip-hed").innerHTML = name;
      document.querySelector("#tooltip-office").innerHTML = data[name].Office;

      if (data[name].Link) {
        tooltip.classList.add("tiktok");
        document.querySelector("#tooltip-link").innerHTML = "<strong>" + data[name].Link + "</strong> <img src='icon.svg' alt='' id='tooltip-icon'>";
      } else {
        tooltip.classList.remove("tiktok");
        document.querySelector("#tooltip-link").innerHTML = "";
      }
    }
  }

  const handleMouseenter = event => {
    positionTooltip(event);
  }

  const handleMousemove = event => {
    positionTooltip(event);
    populateTooltipContent(event);
  }

  const handleMouseleave = event => {
    tooltip.classList.remove("visible");
    tooltip.classList.add("hidden");
  }

  const handleClick = event => {
    window.open("https://www.tiktok.com/" + data[event.target.dataset.lawmaker].Link);
  }

  if (!isTouchDevice()) {
    document.querySelectorAll(".squares-container").forEach(d => {
      d.addEventListener("mouseenter", handleMouseenter);
      d.addEventListener("mousemove", handleMousemove);
      d.addEventListener("mouseleave", handleMouseleave);
    });

    document.querySelectorAll(".tiktok-square").forEach(d => {
      d.addEventListener("click", handleClick);
    });
  }

  pym.then(child => {
    child.sendHeight();
    window.addEventListener("resize", () => child.sendHeight());
  });
}

// Initially load the graphic
// wait for images to load. see: https://developer.mozilla.org/en-US/docs/Web/API/Window/load_event
window.addEventListener("load", onWindowLoaded);